<template>
  <v-data-table v-bind="$attrs" v-on="$listeners">
    <!-- Pass on all named slots -->
    <slot v-for="slot in Object.keys($slots)" :name="slot" :slot="slot" />

    <!-- Pass on all scoped slots -->
    <template
      v-for="slot in Object.keys($scopedSlots)"
      :slot="slot"
      slot-scope="scope"
      ><slot :name="slot" v-bind="scope"
    /></template>
  </v-data-table>
</template>

<script>
export default {
  name: "ADataTable",
};
</script>

<style scoped>
::v-deep .v-input--selection-controls__input {
  margin-right: 0 !important;
}
::v-deep
  .v-data-table-header
  .v-data-table__checkbox
  .v-input--selection-controls__input
  .v-icon {
  color: #ffffff !important;
}
.v-data-table /deep/ .v-data-table-header__icon {
  color: #ffffff !important;
}
::v-deep th {
  background: var(--v-neutralGray-base) !important;
}

/* ::v-deep tbody tr {
  height: 70px !important;
} */

.v-data-table /deep/ .v-data-table-header__icon {
  color: #ffffff !important;
}

::v-deep .v-data-table-header {
  font-family: "Noto Sans JP" !important;
  font-style: normal !important;
  background: var(--v-neutralGray-base) !important;
  color: #ffffff !important;
  height: 32px !important;
  min-height: 32px !important;
}
::v-deep .header-text {
  font-family: "Noto Sans JP" !important;
  font-style: normal !important;
  color: #ffffff !important;
  font-size: 14px !important;
  font-weight: 400 !important;
}
::v-deep .header {
  border-left: thin solid #ffffff !important;
  height: 32px !important;
  min-height: 32px !important;
}
::v-deep.v-data-table .v-data-table__wrapper thead .mdi-checkbox-blank-outline {
  color: #ffffff !important;
}
::v-deep.theme--light.v-data-table.v-data-table--fixed-header thead th {
  background: var(--v-neutralGray-base) !important;
  color: #ffffff !important;
}
::v-deep
  .theme--light.v-data-table
  .v-data-table-header
  th.sortable
  .v-data-table-header__icon {
  color: #ffffff !important;
}
::v-deep .v-data-table__selected .title {
  font-weight: 700 !important;
}
::v-deep .v-data-table__selected {
  background: #edf8ff !important;
}
::v-deep .v-data-table {
  background: #ffffff !important;
  /* color: #006CAD !important; */
  font-weight: 400 !important;
  font-size: 16px !important;
  line-height: 24px !important;
}
::v-deep .secondary-darken5--text {
  color: var(--v-darkCharcoal-base) !important;
  font-weight: 400 !important;
  font-size: 14px !important;
}
::v-deep .primary--text {
  /* font-size: 16px !important; */
}
</style>